<template>
    <div class="header__env-list-wrapper">
        <v-menu>
            <template #activator="{ props }">
                <v-btn variant="text" class="px-2" color="default" v-bind="props" data-testid="teamspace-button">
                    <img
                        v-if="adminUser"
                        class="mr-2 rounded"
                        data-testid="teamspace-logo"
                        :src="getCarpoolAppLogo(adminUser.carpool_app)"
                        :alt="`${getCarpoolAppConf(adminUser.carpool_app).displayName} logo`" />

                    <span class="text-subtitle-2 font-weight-medium" data-testid="teamspace-lang">
                        {{ adminUser?.country?.toUpperCase() || "FR" }}
                    </span>
                </v-btn>
            </template>
            <v-list class="menu-links-list-wrapper" data-testid="teamspace-list">
                <v-list-item
                    v-for="(item, index) in sortedAdminUserTeamspace"
                    :key="index"
                    :value="item.country"
                    class="py-3 px-4"
                    @click="setActiveTeamspace(item.country, item.carpool_app)">
                    <v-list-item-title class="d-flex">
                        <img
                            class="mr-4 rounded"
                            :src="getCarpoolAppLogo(item.carpool_app)"
                            :alt="`${getCarpoolAppConf(item.carpool_app).displayName} logo`" />
                        <span class="text-b1">{{
                            `${getCarpoolAppConf(item.carpool_app).displayName} ${item.country?.toUpperCase() || "FR"}`
                        }}</span>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>
<script setup lang="ts">
import { CARPOOL_APP_INDEX_KAROS } from "@/constants/country"
import { getCarpoolAppConf, getCarpoolAppLogo } from "@/constants/teamspace"
import { Teamspace } from "@/models/core"
import { useAuthStore } from "@/store/core/auth"
import { storeToRefs } from "pinia"
import { computed } from "vue"
import { useRouter } from "vue-router"

const authStore = useAuthStore()
const { adminUser } = storeToRefs(authStore)
const sortedAdminUserTeamspace = computed(() => {
    return adminUser.value?.teamspaces?.sort((a: Teamspace, b: Teamspace) => {
        const appNameA = getCarpoolAppConf(a.carpool_app).displayName
        const appNameB = getCarpoolAppConf(b.carpool_app).displayName
        return appNameA.localeCompare(appNameB)
    })
})
const router = useRouter()

const setActiveTeamspace = (country: string | null, carpoolAppIndex: number) => {
    if (carpoolAppIndex === CARPOOL_APP_INDEX_KAROS && country == "fr") country = null
    const teamspaceItem = {
        country: country,
        carpool_app: carpoolAppIndex
    } as Teamspace

    authStore.setCurrentTeamspace(teamspaceItem).then(() => {
        router.push("/admin/")
    })
}
</script>
<style lang="scss">
.menu-links-list-wrapper {
    width: 198px;
}
</style>
